import { IUser } from "data/user";
import { fetcher } from "utils/ApiUtil";

export interface LogInData {
  token: {
    token: string;
  };
  data: IUser[];
  message: string;
  success: boolean;
}

export interface IUserInfo {
  // hallname: string[];
}

export interface IKakaoLogin {
  response: {
    access_token: string;
    expires_in: number;
    id_token: string;
    refresh_token: string;
    refresh_token_expires_in: number;
    scope: string;
    token_type: string;
  };
  profile: {
    id: string;
    properties: {
      nickname: string;
      profile_image: string;
      thumbnail_image: string;
    };
  };
}

export async function getPoint(
  type: "all" | "useN" | "useY",
  page: string = "1"
) {
  return await fetcher("/api/user/point", {
    type,
    page,
  });
}

export async function getPointApplyDetail(no: string) {
  return await fetcher("/api/user/pointApplyDetail", {
    no,
  });
}

export async function userPhoneCodeSend({
  phone_number,
  code,
}: {
  phone_number: string;
  code: string;
}) {
  return await fetcher("/api/user/sns_send", {
    phone_number,
    code,
  });
}
